/* eslint-disable */
import { useEffect, useState } from "react";
import TableStyle from "../style/table.component";
import { Header, TableProps } from "./interface/interface";

const Table = (props: TableProps) => {
  const [isWide, setIsWide] = useState(window.innerWidth > 700);
  const { headers, currentPage, dataList, setDetail, setIsOpen, size } = props;
  const pageSize = size ? size : 10;
  const getDataForPage = (page: number) => {
    if (props.hasPagination) return dataList;
    const startIndex = (page - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dataList.slice(startIndex, endIndex);
  };
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 700) {
        setIsWide(false);
      } else {
        setIsWide(true);
      }
    }
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  function getNestedData(data: any, path: string) {
    const keys = path.split(".");
    let result = data;
    for (let key of keys) {
      result = result[key];
      if (result === undefined) break;
    }
    return result;
  }
  const formatMessage = (message: string) => {
    if (message.length <= 10) {
      return message;
    }
    const newMessage = message.substring(0, 10);
    return newMessage + " ...";
  };

  function formatDate(dateString: string) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // 월은 0부터 시작하므로 1을 더합니다.
    const day = date.getDate().toString().padStart(2, "0");

    return `${year}-${month}-${day}`;
  }
  return isWide ? (
    <TableStyle marginTop="30px">
      <thead>
        <tr>
          {headers.map((header: Header) => (
            <th key={header.value}>{header.text}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {getDataForPage(currentPage).map((data: any, index: number) => (
          <tr
            key={index}
            onClick={() => {
              if (setDetail) setDetail(data);
              if (setIsOpen) setIsOpen(true);
            }}
          >
            {headers.map((header) =>
              Array.isArray(data[header.value]) &&
              header.value === "rankers" ? (
                <td key={header.value}>{data[header.value].length}명</td>
              ) : typeof data[header.value] === "boolean" ? (
                data[header.value] === false ? (
                  <td key={header.value}>N</td>
                ) : (
                  <td key={header.value}>Y</td>
                )
              ) : header.value === "endDate" && data["endDate"] === null ? (
                <td key={header.value}>상시</td>
              ) : header.value.includes(".") ? (
                <td key={header.value}>{getNestedData(data, header.value)}</td>
              ) : header.subValue &&
                (data[header.subValue] || data[header.value] === "") ? (
                <td key={header.value}>
                  {data[header.value]
                    .split(", ")
                    .filter((value: any) => value !== "ETC")
                    .join(", ") &&
                    `${data[header.value]
                      .split(", ")
                      .filter((value: any) => value !== "ETC")
                      .join(", ")}, `}
                  {data[header.subValue]}
                </td>
              ) : header.value === "message" ? (
                <td key={header.value}>{formatMessage(data[header.value])}</td>
              ) : header.value === "date" ? (
                <td key={header.value}>{formatDate(data[header.value])}</td>
              ) : (
                <td key={header.value}>{data[header.value]}</td>
              )
            )}
          </tr>
        ))}
      </tbody>
    </TableStyle>
  ) : (
    <TableStyle setMobile={true} marginTop="30px">
      <tbody>
        {getDataForPage(currentPage).map((data: any, index: number) => (
          <tr
            key={index}
            onClick={() => {
              if (setDetail) setDetail(data);
              if (setIsOpen) setIsOpen(true);
            }}
          >
            {headers.map((header) => (
              <td key={header.value}>
                <div>{header.text}</div>
                {Array.isArray(data[header.value]) &&
                header.value === "rankers" ? (
                  <div>{data[header.value].length}명</div>
                ) : header.value === "endDate" && data["endDate"] === null ? (
                  <td key={header.value}>상시</td>
                ) : header.value.includes(".") ? (
                  <td key={header.value}>
                    {getNestedData(data, header.value)}
                  </td>
                ) : (
                  <td key={header.value}>{data[header.value]}</td>
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </TableStyle>
  );
};

export default Table;
